import AnalyticsService from "@/services/analytics";
import { useState } from "react";
import { StandardButton } from "@/components/common/StandardButton";

interface PasswordFieldProps {
  label: string;
  required?: boolean;
  className: string;
  onChange: (e: any) => void;
  placeholder: string;
}

function PasswordField(props: PasswordFieldProps) {
  const { label, required = false, className, onChange, ...otherProps } = props;

  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const togglePasswordVisibility = () => {
    AnalyticsService.trackGAEventHandler("authPopupShowHidePassword");
    AnalyticsService.trackMx("authPopupShowHidePassword", {});

    setShowPassword(!showPassword);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    onChange(e); // Call the onChange prop function to lift state up or handle changes
  };

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <label htmlFor="password" className="flex items-center gap-1">
        <span className="label-s-medium text-fg-neutral-strong">{label}</span>
        {required && <span className="text-red-600 label-s-medium">*</span>}
      </label>
      <div className="relative">
        <input
          type={showPassword ? "text" : "password"}
          id="password"
          className="w-full p-2 rounded-lg text-black border border-violet-400 label-s-medium placeholder:text-stone-300 bg-transparent"
          onChange={handlePasswordChange}
          {...otherProps}
        />
        {password && (
          <StandardButton
            type="button"
            id="togglePasswordVisibility"
            onClick={togglePasswordVisibility}
            variant="icon"
            size="icon-xlg"
            className="absolute right-2 top-1/2 -translate-y-1/2"
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {/* Replace with an appropriate eye icon */}
            {!showPassword ? (
              <img src="/images/Eye.svg" alt="" aria-hidden="true" />
            ) : (
              <img src="/images/nimbus_eye-off.svg" alt="" aria-hidden="true" />
            )}
          </StandardButton>
        )}
      </div>
    </div>
  );
}

export default PasswordField;
